import axios, { AxiosResponse } from 'axios';

import { IGetListOfFilesResponse } from '../models/IGetListOfFilesResponse';
import { IGetRefinerResponse } from '../models/IGetRefinerResponse';
import { IGetUserResponse } from '../models/IGetUserResponse';
import { ILocation } from '../models/ILocation';
import { ISelectedRefinerItem } from '../models/ISelectedRefinerItem';
import { ISite } from '../models/ISite';

export class MdiService {
  private static _instance: MdiService;
  private _baseUrl = process.env.REACT_APP_BASE_API_URL + '/api/WHCPortal';

  public static get Instance() {
    return this._instance || (this._instance = new this());
  }

  private buildKqlQueryForSites(sites: Array<string>): string {
    return sites.map(site => `${site}`).join('');
  }

  private buildKqlQuery(currentKQLQuery: string, selectedRefinerItems: ISelectedRefinerItem[], keyword: string): string {
    let query = [];

    // Site KQL query
    query.push(currentKQLQuery);

    // Keyword KQL query
    if (keyword) {
      query.push(keyword);
    }

    // Refiner KQL query
    for (let i = 0; i < selectedRefinerItems.length; i++) {
      const refinerItem = selectedRefinerItems[i];
      query.push(`${refinerItem.property}:"${refinerItem.value}"`);
    }
    
    return query.join(' ');
  }

  public async GetRefiners(location: string): Promise<IGetRefinerResponse[]> {
    const params: any = {
      location
    };
    const result: AxiosResponse<any> = await axios({
      method: 'get',
      url: `${this._baseUrl}/GetRefiners`,
      params: params,
    });

    return result.data.map((item: any) => ({
      title: item.Title,
      property: item.Property,
      siteId: item.SiteId
    } as IGetRefinerResponse));
  }

  public async GetListOfFiles(
    locationIds: string,
    sites: Array<string>,
    keyword: string,
    rowLimit: number,
    startRow: number,
    currentKQLQuery: string,
    selectedRefiners: Array<ISelectedRefinerItem>,
    sortQuery?: string
  ): Promise<IGetListOfFilesResponse> {
    let params: any = {
      locationIds,
      rowLimit,
      startRow
    }
    const kqlQuery = this.buildKqlQuery(currentKQLQuery, selectedRefiners, keyword);

    // if kqlQuery is exist
    if (kqlQuery) {
      params.kqlQuery = kqlQuery;
    }

    params.siteQuery = this.buildKqlQueryForSites(sites);
    const result: AxiosResponse<any> = await axios({
      method: 'get',
      url: `${this._baseUrl}/GetListOfFiles`,
      params: params,
    });

    return result.data;
  }

  public async VerifyToken(): Promise<boolean> {
    const result: AxiosResponse<any> = await axios({
      method: 'get',
      url: `${this._baseUrl}/VerifyToken`,
    });
    return result.data;
  }

  public async GetUser(): Promise<IGetUserResponse> {
    const result: AxiosResponse<any> = await axios({
      method: 'get',
      url: `${this._baseUrl}/GetUser`,
    });
    return result.data;
  }

  public async GetLocations(): Promise<Array<ILocation>> {
    const result: AxiosResponse<any> = await axios({
      method: 'get',
      url: `${this._baseUrl}/GetLocations`,
    });
    return result.data;
  }

  public async GetSites(selectedLocation: string): Promise<Array<ISite>> {
    const result: AxiosResponse<any> = await axios({
      method: 'get',
      url: `${this._baseUrl}/GetSites`,
      params: {
        location: selectedLocation
      }
    });
    return result.data;
  }

  public async Login(email: string, password: string): Promise<any> {
    const result: AxiosResponse<any> = await axios({
      url: `${process.env.REACT_APP_BASE_API_URL}/api/WHCPortal/GetToken`,
      method: 'GET',
      headers: {
        email: email,
        password: password,
      },
    });
    return result;
  }
}
